export default "__VITE_ASSET__yHkuGGrG__"